import Mark from 'mark.js';
import utils from '../utils';

class MarkSearchKeyword {
  constructor(options = {}) {
    this.config = {
      selector: '.o-macro .text-container',
      searchKeyword: utils.getUrlParameter('keyword'),
      ...options
    };
  }

  init() {
    const { searchKeyword, selector } = this.config;

    if (searchKeyword) {
      const macros = document.querySelectorAll(selector);

      macros.forEach(macro => {
        const instance = new Mark(macro);
        instance.mark(searchKeyword);
      });
    }
  }
}

export default MarkSearchKeyword;
